/** 11 §4 impact decals: a `⊢` dimension tick at each wall/pillar contact,
 *  linear fade over FX_DECAL_MS, pool FX_DECAL_MAX (oldest evicted), cleared
 *  at round reset. Cosmetic, per client, identical across clients. */
import { FX_DECAL_MAX, FX_DECAL_MS } from './constants.js'

export interface Decal { x: number; z: number; nx: number; nz: number; bornAt: number; surface: 'wall' | 'pillar'; value: string }

export class DecalPool {
  readonly decals: Decal[] = []

  add(x: number, z: number, nx: number, nz: number, now: number, surface: 'wall' | 'pillar', bounceCount: number): Decal {
    const nl = Math.hypot(nx, nz) || 1
    const d: Decal = { x, z, nx: nx / nl, nz: nz / nl, bornAt: now, surface, value: String(bounceCount) }
    this.decals.push(d)
    while (this.decals.length > FX_DECAL_MAX) this.decals.shift()
    return d
  }

  /** 0..1 remaining opacity. */
  alpha(d: Decal, now: number): number { return Math.max(0, 1 - (now - d.bornAt) / FX_DECAL_MS) }

  prune(now: number): void {
    let w = 0
    for (const d of this.decals) if (this.alpha(d, now) > 0) this.decals[w++] = d
    this.decals.length = w
  }

  clear(): void { this.decals.length = 0 }
  get size(): number { return this.decals.length }
}
